import { ButtonBase, styled as muiStyled } from '@mui/material'

export const MyTimersListingContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
        background: #00000087;
        border-radius: 7px;
`,
)

export const MyTimersListingHeaderContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    padding: 10px;
    border-radius: 7px;
    justify-content: space-between;
    align-items:center;
    .my-timer-heading{
        font-size: 30px;
        color:#fff;
        margin: 0px;
    }
`,
)

export const TimerListingTypeToggleSwitchContainer = muiStyled('div')(
  ({ theme }) => `
  display: grid;
    justify-content: center;
    align-items:center;
    border: 1px solid #fff;
    font-size: 14px;
    grid-template-columns: repeat(2, 1fr);
    border-radius: 3px;
`,
)

export const TimerListingTypeToggleSwitchButton = muiStyled(ButtonBase)(
  ({ theme, selected }) => `
    color: ${selected ? '#000' : '#fff'};
    aspect-ratio:1;
    width:30px;
    background: ${selected ? '#fff' : 'transparent'};
    transition: all 400ms ${theme.transitions.easing.quickInOut};
    padding: 5px 0;
    &:hover{
        background: ${selected ? '#fff' : '#ffffff2b'};
        color: ${selected ? '#000' : '#fff'};
    }
`,
)
